import ErrorBoundary from '../ErrorBoundary/index'
import ErrorPage from '@/views/error-page'

const AppErrorBoundary = ({ children }: { children: React.ReactNode }) => {
    return <ErrorBoundary fallback={<ErrorPage />}>{children}</ErrorBoundary>
}

export default AppErrorBoundary
